export const getToken = async () => {
  const token = await window?.xdk?.authentication?.getUser();
  if (token) {
    return token.accessToken;
  }
};

export const getAzureToken = async () => {
  const token = await window?.xdk?.authentication?.getMsalToken();
  if (token) {
    return token.accessToken;
  }
};
